import { IClientShort } from 'src/app/data/client/interfaces/IClient';

export default function generateNewClientShortData(): IClientShort {
  return {
    archived: false,
    id: '',
  };
}
